import axiosInstance from '../utils/axiosConfig';

export interface Region {
  id: number;
  name: string;
  country_id: number;
}

export const listRegions = async () => {
  const { data } = await axiosInstance.get<Region[]>('/api/v1/regions');
  return data;
}; 